export default __webpack_public_path__ + "static/media/check.00a052b7.svg";